import { AddressBook } from 'common/types/entities/api/addressBook'
import { axios } from 'common/utils'
import { StateKey } from 'common/utils/flipState'
const initailizeAddress: AddressBook = {
  accountNo: null,
  addressBookType: null,
  addressInfo: null,
  alias: null,
  id: null,
  possibleOversea: null,
  modAuditInfo: null,
  phoneNumber1: null,
  phoneNumber2: null,
  regAuditInfo: null,
  regDate: null,
  modDate: null,
}

const FETCH_ADDRESS = 'address/FETCH_ADDRESS'

export const fetchAddress = (curState: StateKey, storeId: string, addressId: string) => async dispatch => {
  const addressResponse = await axios.get<AddressBook>(`/v1/channels/${storeId}/addressBooks/${addressId}`)
  dispatch({
    curState,
    type: FETCH_ADDRESS,
    address: addressResponse && addressResponse.data,
  })
}

const addressReducer = (state = initailizeAddress, action) => {
  switch (action.type) {
    case FETCH_ADDRESS:
      return action.address
    default:
      return state
  }
}

export default addressReducer
